import { Component, OnInit, ViewChild, ElementRef, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, NavigationStart, NavigationExtras, Router } from '@angular/router';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AuthService } from '../../services/auth.service';
import { EnvService } from '../../services/env.service';
import { CommonService } from '../../services/common.service';

import { MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';

import { DelComponent } from '../../confirm/del/del.component';
import { RviewComponent } from './rview/rview.component';

import * as $ from "jquery";

@Component({
	selector: 'app-request',
	templateUrl: './request.component.html',
	styleUrls: ['./request.component.css'],
	providers: [
		{ provide: MAT_DATE_LOCALE, useValue: 'ko-KR' },
	]
})
export class RequestComponent implements OnInit {

	admPageObj:any = "curr";

	logi_user:any;

	frm : FormGroup;

	orderList:any;
	orderCnt:any = [];
	sdate:any;
	edate:any;
	st1:any = 1;
	st2:any = 1;
	st3:any = 1;
	st4:any = 1;
	st5:any = 1;
	st6:any = 1;

	/* 페이징 */
	cp:any = 1;
	paging:any = [];
	paging_start:any = [];
	paging_end:any = [];

	/* 검색관련 */
	skey:any = "";
	sw:any = "";

	autoOrder:any;
	autoProgress:any = 0;

	startDate = new FormControl(new Date());
	endDate = new FormControl(new Date());

	mindate = new Date(new Date().setMonth(new Date().getMonth() - 1));
	maxdate = new Date(new Date().setMonth(new Date().getMonth() + 1));

	@ViewChild('sd') sdElement: ElementRef;
	@ViewChild('ed') edElement: ElementRef;

	constructor(
		private http: HttpClient,
		public router: Router,
		public route: ActivatedRoute,
		private env: EnvService,
		public dialog: MatDialog,
		private fb: FormBuilder,

		private authService: AuthService,
		private func: CommonService,
	) {
		this.frm = fb.group({
			sdate: ['', [Validators.required]],
			edate: ['', [Validators.required]],
			sw: ['', [Validators.required]],
			st1: ['1'],
			st2: ['1'],
			st3: ['1'],
			st4: ['1'],
			st5: ['1'],
			st6: ['1'],
		});

	}

	ngOnInit() {
		this.autoOrder = setInterval(() => {
			this.autoProgress = this.autoProgress + 10;
			if( this.autoProgress > 100 )
			{
				this.autoProgress = 0;
				this.getOrderList(this.cp);
			}
		}, 1000);


		this.cp = this.func.getParameterByName("page", window.location.href);
		if( this.cp == null ){ this.cp = 1; }

		this.sdate = this.func.getParameterByName("sdate", window.location.href);
		if( this.sdate == null ){ this.sdate = this.sdElement.nativeElement.value; }
		else{ this.frm.get('sdate').setValue(this.sdate); this.startDate = new FormControl(new Date(this.sdate)); }

		this.edate = this.func.getParameterByName("edate", window.location.href);
		if( this.edate == null ){ this.edate = this.edElement.nativeElement.value; }
		else{ this.frm.get('edate').setValue(this.edate); this.endDate = new FormControl(new Date(this.edate)); }

		this.skey = this.func.getParameterByName("skey", window.location.href);
		if( this.skey == null ){ this.skey = ""; }

		this.sw = this.func.getParameterByName("sw", window.location.href);
		if( this.sw == null ){ this.sw = ""; }
		else{ this.frm.get('sw').setValue(this.sw); }

		this.st1 = this.func.getParameterByName("st1", window.location.href);
		if( this.st1 == null ){ this.st1 = "1"; }

		this.st2 = this.func.getParameterByName("st2", window.location.href);
		if( this.st2 == null ){ this.st2 = "1"; }

		this.st3 = this.func.getParameterByName("st3", window.location.href);
		if( this.st3 == null ){ this.st3 = "1"; }

		this.st4 = this.func.getParameterByName("st4", window.location.href);
		if( this.st4 == null ){ this.st4 = "1"; }

		this.st5 = this.func.getParameterByName("st5", window.location.href);
		if( this.st5 == null ){ this.st5 = "1"; }

		this.st6 = this.func.getParameterByName("st6", window.location.href);
		if( this.st6 == null ){ this.st6 = "1"; }

		this.resetStatus();

		this.autoOrder = setInterval(() => {
			this.getOrderList(this.cp);
		}, 10000);
	}

	ngAfterViewInit() {
		this.getOrderList(this.cp);
	}

	async getOrderList(num) {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("logi_code", this.env.COM_CODE);
		formData.append("page", num);
		formData.append("skey", this.skey);
		formData.append("sw", this.frm.get('sw').value);
		formData.append("sdate", this.sdElement.nativeElement.value);
		formData.append("edate", this.edElement.nativeElement.value);
		formData.append("st1", this.frm.get('st1').value);
		formData.append("st2", this.frm.get('st2').value);
		formData.append("st3", this.frm.get('st3').value);
		formData.append("st4", this.frm.get('st4').value);
		formData.append("st5", this.frm.get('st5').value);
		formData.append("st6", this.frm.get('st6').value);
		formData.append("listnum", 15);

		this.http.post(this.env.API_URL + 'api/order.list_adm.php', formData).subscribe((response) => {
			this.orderList = response['list'];
			this.orderCnt = response['cnt'];

			this.paging = response['paging']['pnum'];
			this.paging_start = response['paging']['start'];
			this.paging_end = response['paging']['end'];
		});
	}

	selectPage( num, ev ) {
		this.getOrderList(num);
		this.cp = num;

		let sc_params = "";

		if( this.skey ){ sc_params += "&skey="+this.skey; }
		if( this.sw ){ sc_params += "&sw="+this.sw; }

		history.pushState(null, document.title, window.location.pathname+"?page="+num+sc_params);
	}

	orgValueChange(v) {
		var date = v.split("-");
		this.mindate = new Date(new Date(date[0], date[1], date[2]).setDate(-31));
		this.maxdate = new Date(new Date(date[0], date[1], date[2]).setDate(31));
	}

	async orderView(idx) {
		const modal = this.dialog.open(RviewComponent,{
			panelClass: 'openwrite-class',
			maxWidth: '1100px',
			disableClose: true,
			data: {
				idx: idx
			},
		});

		modal.afterClosed().subscribe(dataReturned => {
			if( dataReturned )
			{
				if( dataReturned['data']['refresh'] == "1" )
				{
				}
			}
		});
	}

	async delConfirm(idx) {
		const dialogRef = this.dialog.open(DelComponent,{
			panelClass: 'confirm-class',
			width: "280px",
			data: {
				title: '오더 삭제',
				message: '해당 오더를 삭제하시겠습니까? 삭제된 내용은 복구하실 수 없습니다.',
				idx: idx
			},
		});

		dialogRef.afterClosed().subscribe(result => {
			this.orderDel(result);
		});
	}

	async orderDel(idx) {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("idx", idx);

		this.http.post(this.env.API_URL + 'api/order.delete.php', formData).subscribe((response) => {
			this.getOrderList(1);
		});
	}

	rview(idx) {
		this.st1 = this.frm.get('st1').value;
		this.st2 = this.frm.get('st2').value;
		this.st3 = this.frm.get('st3').value;
		this.st4 = this.frm.get('st4').value;
		this.st5 = this.frm.get('st5').value;
		this.st6 = this.frm.get('st6').value;

		let navigationExtras: NavigationExtras = {
			queryParams: {
				idx: idx,
				page: this.cp,
				sw: this.frm.get('sw').value,
				sdate: this.sdElement.nativeElement.value,
				edate: this.edElement.nativeElement.value,
				st1: this.st1,
				st2: this.st2,
				st3: this.st3,
				st4: this.st4,
				st5: this.st5,
				st6: this.st6
			}
		};

		this.router.navigate(['/admin/request/rview'], navigationExtras);
	}

	telBoxToggle() {
		$(".tel-box-toggle a").toggleClass("on");

		if( $(".tel-box-toggle a").hasClass("on") )
		{
			$(".tel-box-toggle a em").text("늘이기");
		}
		else
		{
			$(".tel-box-toggle a em").text("줄이기");
		}

		$("#call-layer").toggleClass("telbox-none");
	}

	statusAll() {
		if( $(".btn-co1").hasClass("on") )
		{
			$(".psst").removeClass("on");
			this.frm.get('st1').setValue("0");
			this.frm.get('st2').setValue("0");
			this.frm.get('st3').setValue("0");
			this.frm.get('st4').setValue("0");
			this.frm.get('st5').setValue("0");
			this.frm.get('st6').setValue("0");
		}
		else
		{
			$(".psst").addClass("on");
			this.frm.get('st1').setValue("1");
			this.frm.get('st2').setValue("1");
			this.frm.get('st3').setValue("1");
			this.frm.get('st4').setValue("1");
			this.frm.get('st5').setValue("1");
			this.frm.get('st6').setValue("1");
		}
	}

	statusOn(i) {
		var a = i - 1;
		if( $(".btn-co"+i).hasClass("on") )
		{
			$(".btn-co"+i).removeClass("on");
			this.frm.get('st'+a).setValue("0");
		}
		else
		{
			$(".btn-co"+i).addClass("on");
			this.frm.get('st'+a).setValue("1");
		}

		var cc = 0;
		$(".cst").each(function(){
			if( $(this).hasClass("on") ){ cc++; }
		});

		if( cc == 6 )
		{
			$(".btn-co1").addClass("on");
		}
		else
		{
			$(".btn-co1").removeClass("on");
		}
	}

	resetStatus() {
		var chk = [this.st1, this.st2, this.st3, this.st4, this.st5, this.st6];
		var cc = 0;

		for( var i=0; i < chk.length; i++ )
		{
			var c = i + 2;
			var d = i + 1;

			if( chk[i] == 1 )
			{
				$(".btn-co"+c).removeClass("on");
				$(".btn-co"+c).addClass("on");
				this.frm.get('st'+d).setValue("1");
				cc++;
			}
			else
			{
				$(".btn-co"+c).removeClass("on");
				this.frm.get('st'+d).setValue("0");
			}
		}

		if( cc != 6 )
		{
			$(".btn-co1").removeClass("on");
		}
	}
}
